// Centralized color mapping utilities for pushback statuses and client log severities.
// Keeping original color names to preserve existing UX expectations.

export function getPushbackStatusColor(status?: string): string {
    if (!status) return 'black';
    const s = status.toLowerCase();
    switch (s) {
        case 'unprocessed':
            return 'black';
        case 'processing':
        case 'awaitingwebhookupdate':
            return 'darkorange';
        case 'complete':
            return 'green';
        case 'error':
        case 'requeue':
        case 'loanlockbyanotheruser':
        case 'awaitingwebhookretry':
        case 'awaitingwebhookunknown':
            return 'maroon';
        case 'abandoned':
            return 'red';
        default:
            return 'darkblue';
    }
}

export function getClientLogSeverityColor(severity?: string): string {
    if (!severity) return 'black';
    switch (severity.toLowerCase()) {
        case 'warning':
            return 'orange';
        case 'complete':
            return 'green';
        case 'alert':
            return 'red';
        default:
            return 'black';
    }
}
